const getTranslationKey = (
  collection: { id: string; description: string }[],
  value: string,
) =>
  collection.map((item): string => (item.id === value ? item.description : ''));

export default getTranslationKey;
